// ------------------------------------
// Constants
// ------------------------------------
export const ADD_PRODUCT = 'ADD_PRODUCT'
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT'
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const CLEAR_SEL_PRODUCT = 'CLEAR_SEL_PRODUCT'
// ------------------------------------
// Actions
// ------------------------------------
export function addProduct(undef, product) {
  return (dispatch, getState) => {
    dispatch({
      type: ADD_PRODUCT,
      payload: { ...product, initPrice: product.price }
    })
  }
}

export function removeProduct(undef, product) {
  return (dispatch, getState) => {
    dispatch({
      type: REMOVE_PRODUCT,
      payload: product
    })
  }
}
export function changeReduc(undef, product, reduc) {
  const discountPrice =
    product.reduc === void 0
      ? '0.00'
      : (
          Number(product.initPrice) -
          Number(product.initPrice) * reduc / 100
        ).toFixed(2)
  product = Object.assign({}, product, {
    reduc: reduc === 0 ? null : reduc,
    price: discountPrice
  })
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PRODUCT,
      payload: product
    })
  }
}

export function clearSelectedProducts() {
  return (dispatch, getState) => {
    dispatch({
      type: CLEAR_SEL_PRODUCT
    })
  }
}

export const actions = {
  addProduct,
  removeProduct,
  clearSelectedProducts
}

// ------------------------------------
// Action Handlers
// ------------------------------------
function calculTotal(products) {
  let total = 0
  products.map(product => {
    const reduc = product.reduc || 0
    total += product.price - product.price * reduc / 100
    return null
  })
  return total
}
const ACTION_HANDLERS = {
  [ADD_PRODUCT]: (state, action) => {
    let products = [
      ...state.list,
      { ...action.payload, key: state.list.length }
    ]
    let total = calculTotal(products)
    return Object.assign({}, state, { list: products, total: total })
  },
  [UPDATE_PRODUCT]: (state, action) => {
    let products = [...state.list]
    products[action.payload.key] = action.payload
    let total = calculTotal(products)
    return Object.assign({}, state, { list: products, total: total })
  },
  [REMOVE_PRODUCT]: (state, action) => {
    const index = action.payload.key
    let products = [
      ...state.list.slice(0, index),
      ...state.list.slice(index + 1)
    ]
    products = products.map((product, index) => ({ ...product, key: index }))
    let total = calculTotal(products)
    return Object.assign({}, state, { list: products, total: total })
  },
  [CLEAR_SEL_PRODUCT]: (state, action) =>
    Object.assign({}, state, { list: [], total: 0 })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], total: 0 }
export default function tableReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/selectedProducts.js